<template>
	<div class="Aindex">
		<div class="topbanner">
			<img src="../static/bg_title background@2x.png" alt="">
		</div>
		<p class="title">
			估值教程
		</p>
		<div class="gifImg">
			<img src="" alt="">
		</div>
		<div class="footer">
			<div class="butn">开始估值</div>
		</div>
	</div>
</template>
<script type="text/javascript">
	export default {
		methods:{
			
		}
	}
</script>
<style scoped>
	.Aindex{
		width: 100%;
		background:#D2F1E4;
	}
	.topbanner{
		width: 100%;
	}
	.topbanner img{
		width: 100%;
	}
	.title{
		font-size: 20px;
		color:#18BD6F;
		font-weight: bold;
		margin-top:.3rem;
		text-indent:2em;
		margin-bottom: .24rem;
	}
	.gifImg{
		width: 80%;
		height:5.6rem;
		background:#fff;
		margin: 0 auto;
		margin-bottom:.24rem;
	}
	.gifImg img{
		width: 100%;
		height: 100%;
		object-fit: contain;
	}
	.footer{
		width: 100%;
		height: .58rem;
		background:#fff;
		padding-top: .15rem;
	}
	.footer .butn{
		width: 90%;
		height: .44rem;
		background:#18BD6F;
		color:#fff;
		line-height:.44rem;
		text-align:center;
		font-size: 16px;
		margin: 0 auto;
		border-radius:4px;
	}
</style>